import { useState, useEffect } from "react";
import { Heading, Box, theme, Text, Center, Tooltip, Flex, useColorMode, useColorModeValue } from "@chakra-ui/react";
// import {
//   FlexibleWidthXYPlot,
//   VerticalBarSeries,
//   LineSeries,
//   Crosshair,
//   YAxis,
// } from "react-vis";
import moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";
import { QuestionIcon } from "@chakra-ui/icons";
import numbro from "numbro";
import { ComposedChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
import { format, formatDistance } from "date-fns";
import { getAccount } from "utils/sessionHelper";
import { useSession } from "next-auth/client";
import { convertToAccountTimezone, convertToAccountTimezoneReversed } from "utils/helpers";
import { layerStyle, textStyle } from "theme/names";

export function FollowerGain({
  stats = [],
  isLoading = false,
  previousDayStat = undefined,
  dateSeries = [],
  isDataCollectionWarning = false,
}) {
  const [index, setIndex] = useState(null);
  const [hoveredPoint, setHoveredPoint] = useState<any>();
  const [data, setData] = useState<any>([]);
  const [crosshairValues, setCrosshairValues] = useState([]);
  const { colorMode } = useColorMode()
  const [session, loading] = useSession();
  
  // console.log('fg - stats:', stats)
  // console.log('fg - stats:', stats?.map(x => x?.dateFetched?.toDate()));

  useEffect(() => {
    if (stats && stats?.length > 0) {
      let newSeries: any = [...dateSeries];
      stats.forEach((s: any) => {
        let date = s.dateFetched.toDate ? s.dateFetched.toDate() : s.dateFetched;
        let {date: dateTimezoned, timezoneDiff} = convertToAccountTimezone(date, "UTC");
        const formattedDate = moment(dateTimezoned).format("MMM. Do ’YY");
        const index = newSeries.findIndex((n) => n.date === formattedDate);
        if (index !== -1) {
          newSeries[index].followers_count = s.followers_count;
        }
      });
      // console.log('newSeries:', newSeries)
      setData(newSeries);
    } else {
      setData([]);
    }
  }, [stats]);

  let newArr: any = data.slice().reverse();

  newArr.forEach((d, i, arr) => {
    d.x = arr?.length - i - 1;
    d.y = d.followers_count || arr[i - 1]?.y;
  });
  const lastElement = newArr[0]
  const secondLastElement = newArr[1]
  if (!lastElement?.y && secondLastElement) {
    lastElement.y = secondLastElement?.y
  }

  // Line data

  const totalFollowers = newArr.reverse();

  // Bar data
  const followersDiff = data.map((d, i, arr) => {
    return {
      x: i,
      y: !d.followers_count
        ? 0
        : d.followers_count -
            (i === 0
              ? // @ts-ignore
                previousDayStat?.followers_count
                ? // @ts-ignore
                  previousDayStat?.followers_count
                : d.followers_count
              : arr[i - 1].followers_count) || 0.01,
      followers: totalFollowers[i].y,
      followersLabel: numbro(totalFollowers[i].y ?? 0).format({totalLength: 2,}) ?? 0,
      // followersLabel: "",
      color: i === index ? "dodgerblue" : colorMode === "dark" ? "darkgray" : "lightgray",
      date: d.date,
    };
  });

  let max = Math.max(...followersDiff.map(x => x.followers));
  let min = Math.min(...followersDiff.map(x => x.followers));
  let middle = (max + min) / 2;
  let ticks = [min, middle, max];

  // console.log(ticks);
  // console.log(followersDiff);

  // @ts-ignore
  const hoveredData = data[index];
  // @ts-ignore
  const beforeHoveredItem = index === 0 ? previousDayStat : data[index - 1];
  const followerDiff =
    hoveredData?.followers_count - beforeHoveredItem?.followers_count;

  const maxYDomainBarSeries =
    Math.max(...followersDiff.map((item) => item.y)) > 0.01
      ? Math.max(...followersDiff.map((item) => item.y))
      : 1;

  return (
    <Box>
      <Flex alignItems="center">
        <Text
          textStyle={textStyle["h2.bold.standard"]}
        >
          Daily Follower Gain
        </Text>
        <Tooltip
          hasArrow
          label={
            <>
              <Text>
                Your daily followers change is represented by bars and total
                followers in red.
              </Text>
              <br />
              <Text>
                Note: Analytics kicks off only after you activate it so there
                are chances you might see some blank spaces in charts because we
                won't have earlier data.
              </Text>
            </>
          }
        >
          <QuestionIcon color="gray.400" mt={1} ml={2} />
        </Tooltip>
      </Flex>
      {
        isDataCollectionWarning && (
          <Text mb={10} fontSize="sm" color="gray.500"><i>⚠️ Stats might be wrong since data collection started on {format(new Date(getAccount(session)?.dateAdded?._seconds*1000), 'yyyy/MM/dd') }</i></Text>
        )
      }
      {!isLoading && stats?.length <= 0 && (
        <Text p="8" textAlign="center">
          No chart data found. Please try a different timeframe
        </Text>
      )}
      {isLoading && (
        <Center pt={10}>
          <PuffLoader
            color={"hsl(203, 100%, 36%)"}
            loading={isLoading}
            css="display: block; margin: 0 auto; border-color: red;"
            size={50}
          />
        </Center>
      )}
      {!isLoading && (
        // <Box position="relative" h="300px" maxW="100%" ml={{base: "0", md: "4"}} mt={{ base: "4", md: "8" }}>
        //   <Box position="absolute" maxW="100%" w="100%" mt="8" >
        //     <FlexibleWidthXYPlot
        //       height={300}
        //       xType="ordinal"
        //       onMouseLeave={() => {
        //         setIndex(null);
        //         setCrosshairValues([]);
        //       }}
        //     >
        //       <VerticalBarSeries
        //         yDomain={[
        //           Math.min(...followersDiff.map((item) => item.y)),
        //           maxYDomainBarSeries,
        //         ]}
        //         data={followersDiff}
        //         color="#15b7f7"
        //         colorType="literal"
        //       />
        //     </FlexibleWidthXYPlot>
        //   </Box>
        //   <Box position="absolute" maxW="100%" w="100%" mt="8" zIndex="1" overflow="visible">
        //     <FlexibleWidthXYPlot
        //       // yDomain={[
        //       //   20000,
        //       //   22000
        //       // ]}
        //       yDomain={[
        //         Math.min(...totalFollowers.map((item) => item.y)) - (Math.min(...totalFollowers.map((item) => item.y)) * 0.01),
        //         Math.max(...totalFollowers.map((item) => item.y)) + (Math.max(...totalFollowers.map((item) => item.y)) * 0.01)
        //       ]}
        //       height={300}
        //       width={1000}
        //       // style={{ paddingRight: 35 }}
        //       xType="ordinal"
        //       onMouseLeave={() => {
        //         setIndex(null);
        //         setCrosshairValues([]);
        //       }}
        //     >
        //       <LineSeries
        //         data={totalFollowers}
        //         curve="curveMonotoneX"
        //         color={theme.colors.blue[400]}
        //         onNearestX={(d, { index: xIndex }) => {
        //           setIndex(xIndex);
        //           if (d.y !== 0) {
        //             // @ts-ignore
        //             setCrosshairValues([followersDiff[xIndex]]);
        //           } else {
        //             setCrosshairValues([]);
        //           }
        //         }}
        //         onValueMouseOver={(value) => {
        //           setHoveredPoint(value);
        //         }}
        //         onValueMouseOut={() => setHoveredPoint(null)}
        //       />
        //       <YAxis orientation="right" />
        //       <Crosshair values={crosshairValues}>
        //         <Box
        //           background={useColorModeValue("white", "gray.600")}
        //           padding="4"
        //           boxShadow="dark-lg"
        //           color={useColorModeValue("black", "white")}
        //           borderRadius="xl"
        //           textAlign="center"
        //           width="28"
        //         >
        //           {hoveredData?.followers_count ? (
        //             <>
        //               {followerDiff ? (
        //                 <Text fontWeight="bold" fontSize="xs">
        //                   {followerDiff > 0 && "+"}
        //                   {numbro(followerDiff).format({ thousandSeparated: true })} followers
        //                 </Text>
        //               ) : null}

        //               <Text fontSize="11px" my="0.5">
        //                 Total: {numbro(hoveredData?.followers_count).format({ thousandSeparated: true })}
        //               </Text>
        //             </>
        //           ) : (
        //             <>
        //               <Text fontWeight="bold" fontSize="xs">
        //                 No Data Available!
        //               </Text>
        //               <Text mt="1" fontSize="11px" mb="1">
        //                 {
        //                   hoveredData?.date === moment().format("MMM. Do ’YY") ? 
        //                     "Analytics hasn't analyzed today's data yet" : 
        //                     "Analytics kicks off only after the date you activate it"
        //                 }
        //               </Text>
        //             </>
        //           )}

        //           <Text fontSize="11px">{hoveredData?.date}</Text>
        //         </Box>
        //       </Crosshair>
        //     </FlexibleWidthXYPlot>
        //   </Box>
        // </Box>
        <Box position="relative" h="240px" maxW="100%"
          // ml={{ base: "0", md: "4" }}
          mt={{ base: "4", md: "8" }}
          // border="1px"
          // borderColor={"teal.300"}
          // borderRadius="xl"
          px="0"
          py="2"
          layerStyle={layerStyle["bg.border.rounded"]}
        >
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart
              width={500}
              height={300}
              data={followersDiff}
              margin={{
                top: 5,
                right: 10,
                left: 10,
                bottom: 5,
              }}
            >
              <XAxis dataKey="date" hide={true}/>
              <YAxis yAxisId="left" type="number" orientation="right" stroke="#82ca9d" hide={true} />
              <YAxis dataKey="followers" yAxisId="right" type="number" orientation="right" hide={false} domain={[dataMin => (dataMin * 0.99), dataMax => (dataMax * 1.01)]}
                tickFormatter={(value) => numbro(value).format({totalLength: 3})}
                // tickCount={5}
                stroke={theme.colors.gray[300]}
                // tick={{stroke: theme.colors.gray[300], strokeWidth: 0.8}}
                tickLine={true}
                axisLine={false}
                ticks={ticks}
              />
              <Bar yAxisId="left" type="monotone" dataKey="y" fill={theme.colors.gray[300]} />
              <Line yAxisId="right" type="monotone" dataKey="followers" stroke={theme.colors.blue[300]} strokeWidth={2} dot={false} />
              <RechartsTooltip content={({active, payload, label}) => {
                // console.log(payload);
                let followerDiff: any = 0; 
                let followerCount: any = 0; 
                let date: any = "na"; 

                if (payload && payload?.length > 1) {
                  followerDiff = payload[0].value;
                  followerCount = payload[1].value;
                  date = payload[0].payload.date;
                }

                return (
                  <Box
                    // background={useColorModeValue("white", "gray.600")}
                    padding="4"
                    boxShadow="lg"
                    layerStyle={layerStyle["bg.border.rounded"]}
                    textStyle={textStyle["body.medium.light"]}
                    // color={useColorModeValue("black", "white")}
                    // borderRadius="xl"
                    textAlign="center"
                    width="28"
                  >
                    {payload && payload?.length > 1 ? (
                      <>
                        {followerDiff ? (
                          <Text fontWeight="bold" fontSize="xs">
                            {followerDiff > 0 && "+"}
                            {numbro(followerDiff).format({ thousandSeparated: true })}
                          </Text>
                        ) : null}

                        <Text fontSize="11px" my="0.5">
                          Total: {numbro(followerCount).format({ thousandSeparated: true })}
                        </Text>
                      </>
                    ) : (
                      <>
                        <Text fontWeight="bold" fontSize="xs">
                          No Data Available!
                        </Text>
                      </>
                    )}
                    <Text mt={4} fontSize="11px"><i>{date}</i></Text>
                  </Box>
                )
              }} />
            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Box>
  );
}
